import { render } from "./TokenLogin.vue?vue&type=template&id=33eed74b&scoped=true"
import script from "./TokenLogin.vue?vue&type=script&lang=js"
export * from "./TokenLogin.vue?vue&type=script&lang=js"

import "./TokenLogin.vue?vue&type=style&index=0&id=33eed74b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33eed74b"]])

export default __exports__